module.exports = __webpack_public_path__ + "media/images/vp/icon.events-861eb91fbaa6e79684f0e65f1897983c.svg";